import { configureStore } from '@reduxjs/toolkit';

import filterReducer from './features/filterSlice';
import areaBalanceDetailsReducer from './features/areaBalanceDetailsSlice';
import areaReducer from './features/areaDetailsSlice';
import areaHealthReducer from './features/areaHealthSlice';
import lanesReducer from './features/lanesSlice';
import laneDetailsReducer from './features/laneDetailSlice';
import mapReducer from './features/mapSlice';
import networkHealthReducer from './features/networkHealthSlice';
import networkRxReducer from './features/networkRxSlice';
import shipperHealthReducer from './features/shipperHealthSlice';
import shippersReducer from './features/shippersSlice';
import shipperDetailsReducer from './features/shipperDetailsSlice';
import topLanesReducer from './features/topLanesSlice';
import userReducer from './features/userSlice';

export const store = configureStore({
    reducer: {
        area: areaReducer,
        areaBalance: areaBalanceDetailsReducer,
        areaHealth: areaHealthReducer,
        filters: filterReducer,
        lanes: lanesReducer,
        lane: laneDetailsReducer,
        map: mapReducer,
        networkHealth: networkHealthReducer,
        networkRx: networkRxReducer,
        shippers: shippersReducer,
        shipper: shipperDetailsReducer,
        shipperHealth: shipperHealthReducer,
        topLanes: topLanesReducer,
        user: userReducer,
    },
    devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;

export type RootDispatch = typeof store.dispatch;
